import {
    //SET_CARGUES,
    //SET_DIALOG_ACTIVE,

} from "@/views/cargues/store/types/types.js";

const mutations= {
    //[SET_CARGUES]: (state, payload) => state.cargue = payload,
    //[SET_DIALOG_ACTIVE]: (state, { status, index }) => state.providers[index]['activeDialogProvider'] = status,

}

export default mutations